import { SELECT_BACKGROUND, SELECT_MEDIA } from './mediaReducer';


export const selectBackgroundAction = (payload) => {
  return (
    {
      type: SELECT_BACKGROUND,
      payload
    });
};

export const selectMediaAction = (payload) => {
  return (
    {
      type: SELECT_MEDIA,
      payload
    });
};


